export default __webpack_public_path__ + "static/media/thumbnail.295a4bf2.png";